import React from "react";
import axios from 'axios';
import { useEffect, useState ,useRef} from 'react';
import Loader from "../components/loader";
import { getNBNApiHeader } from "utlis/commonfunctions";
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'utlis/authContext';

    const Address = ({ getVispHandler, addressVerified, passNbnSessionId, tokenValue, getAvailablePlan, userToken }) => {
    const addressToken = tokenValue;
	const headers = getNBNApiHeader();
	const apiUrl = process.env.REACT_APP_API_URL;
	const apiKey = process.env.REACT_APP_API_TOKEN;

	const [address, setAddress] = useState([]);
	const [text, setText] = useState('');
	const [addressDrop, setAddressDrop] = useState('');
	const [addressReset, setAaddressReset] = useState(true);
	const [suggestions, setSuggestions] = useState([]);
	const [isReadonly, setIsReadonly] = useState(false);
	const [validAddress, setValidAddress] = useState(false);
	const [searchLoader, setSearchLoader] = useState(false);
	const [techType, setTechType] = useState(false);
	const [nbnSessionId, setNbnSessionId] = useState('');
	const [debounceTimer, setDebounceTimer] = useState(null);
	const textInput = useRef(null);

	const { isAuthenticated } = useAuth();
	const navigate = useNavigate();
	if(isAuthenticated==false){
	  navigate('/login', { replace: true });
	}
	
	const onChangeHandler = async (addressText) => {

		setAddressDrop(false);
		setText(addressText);

		if (addressText.length >= 4) {
			
			if (debounceTimer) {
                clearTimeout(debounceTimer);
            }

			// Set new debounce timer
            const newTimer = setTimeout(() => {
                performSearch(addressText);
            }, 700);

            setDebounceTimer(newTimer);
			const performSearch = async (addressText) => {
			//setCounter(prevCounter => prevCounter + 1);
			setSearchLoader(true);
            
			try {
				const payload = {
					"address_search_term":addressText,
					"nbn_session_id": nbnSessionId,
					"token":  addressToken 

				};

				const response = await axios.post(apiUrl + 'nbn/get-autocomplete-address', payload, { headers:headers});

				if (response.status === 200) {

					let addressData = response.data.data.data.results;
					setAddress(addressData);
					setAddressDrop(true);
					setSearchLoader(false);
					setAaddressReset(false);

					if (response.data.data.nbn_session_id) {
						let nbn_session_id = response.data.data.nbn_session_id;
						setNbnSessionId(nbn_session_id);
					}
				} else {
					setAddressDrop(false);
				}
			} catch (error) {
				setAddressDrop(false);
			}
		};
		} else {
			setSuggestions([]);
			setAddressDrop(false);
		}

		//setSuggestions(address); //remove due to issue
		//setText(addressText); //remove due to issue
	};

	useEffect(() => {
		setSuggestions(address);
	}, [address]);

	const suggestionHandler = (suggestion, addressId) => {
		setText(suggestion);
		setSuggestions([]);
		setIsReadonly(true);

		if (addressId !== null) {
			clearTimeout(debounceTimer.current);
			checkVispQualification(suggestion, addressId);
		}

	}

	const resetHandler = () => {
		setAaddressReset(true);
		setSuggestions([]);
		setText('');
		setIsReadonly(false);
		setValidAddress(false);
		addressVerified(false);
	}

	const checkVispQualification = (addressName, addressId) => {

		setSearchLoader(true);
		setAaddressReset(true);

		if (addressId !== '' && nbnSessionId !== '') {

			const runAddressCheck = async () => {

				const payload = {
					"addressId": addressId,
					"addressName": addressName,
					"nbn_session_id": nbnSessionId
				}

				let res = await axios.post(apiUrl + 'nbn/get-address-verification', payload, { headers:headers}).then(async response => {

					if (response.status === 200) {
						if (response.data.data.service_availability_response) {
							//setTimeout(() => {
							
							const payload = {

								"visp_qualification_id": response.data.data.visp_qualification_id,

								"nbn_session_id": nbnSessionId

							}

						setTimeout(
							function() {
							let res =  axios.post(apiUrl + 'nbn/fetch-nbn-visp-qualification', payload, { headers:headers}).then(async apiresponse => {
								if (apiresponse.status === 200) {
									
									if (apiresponse.data.data.address_availability == 'yes') {

										
											
										
										setTechType(response.data.data.service_availability_response.technologyType);

										getVispHandler(response.data.data.visp_qualification_id);

										setValidAddress('valid');

										passNbnSessionId(nbnSessionId)

										setSearchLoader(false);

										addressVerified(true);

										getAvailablePlan(apiresponse.data.data.plans);

										setAaddressReset(false);
										
									
									} else {

										getVispHandler(null);

										setValidAddress('invalid');

										setSearchLoader(false);

										addressVerified(false);

										getAvailablePlan([]);

										setAaddressReset(false);

									}

								

								}

							}).catch(error => {

								getVispHandler(null);

								setValidAddress('invalid');

								setSearchLoader(false);

								addressVerified(false);
								getAvailablePlan([]);

								setAaddressReset(false);

							});
						}, 15000);
						
						}


					} else {
						getVispHandler(null);
						setValidAddress('invalid');
						setSearchLoader(false);
						addressVerified(false);

						setAaddressReset(false);

					}

				}).catch(error => {

					setValidAddress('invalid');
					getVispHandler(null);
					setSearchLoader(false);
					addressVerified(false);
					getAvailablePlan([]);

					setAaddressReset(false);



				});
			}

			runAddressCheck();

		} else {
			getAvailablePlan([]);
			setValidAddress(false);
			getVispHandler(null);
			setSearchLoader(false);
			addressVerified(false);

			setAaddressReset(false);


		}
	}
	
	const planSelect = () => {

		const releventDiv = document.getElementById('planSelectionBox');
		releventDiv.scrollIntoView({ behavior: "smooth" });

	}

     useEffect(()=>{
		 addressScroll()
		 if (textInput.current) {
			textInput.current.focus();
		  }
	 },[])

	const addressScroll=()=>{
		const releventDiv = document.getElementById('AdressSelectBox');
		releventDiv.scrollIntoView({ behavior: "smooth" });
	}

	return (

		<div className="container" id="AdressSelectBox">
			<section className="common-section">
				<div className="row">
					<div className="col-md-12">
						<div className="header-title">
							<h2 className="h3">1. Enter Customer’s Address</h2>
						</div>
						<div className="search-bar-container">
							<div className="search-bar">

								<input type="text" className="form-control search-input" placeholder="Unit 43, 85 Low Street, Thomastown, SA 5149..." readOnly={isReadonly} onChange={e => onChangeHandler(e.target.value)} value={text}    ref={textInput} />
								<div className="search-icon">

									{addressReset ?
										<button type="submit" style={{ border: 'none', backgroundColor: 'transparent', color: '#d30058' }}><i className="fa fa-search"></i></button>
										:
										<button type="submit" style={{ border: 'none', backgroundColor: 'transparent', color: '#d30058' }} onClick={e => resetHandler()}><i className="fa fa-close"></i></button>
									}

								</div>


								{text !== '' && addressDrop && suggestions && (
									<ul className="dropDown">
										{addressDrop && suggestions && suggestions.map((suggestion, i) =>

											<li key={i} onClick={() => suggestionHandler(suggestion.name, suggestion.addressId)}>{suggestion.name}</li>


										)}
									</ul>
								)}

							</div>
						</div>

						{text === false && (
							<p style={{ textAlign: 'left', paddingLeft: '15px', fontSize: '14px', color: '#8c8c8c' }}>
								Start typing ,Customer’s address to get started.
							</p>
						)}


						{searchLoader === true && (

							<div className="search-loader">
								<Loader />
								<p>If you don't get a result in 20 seconds refresh the browser and try again.</p>
							</div>

						)}

						{validAddress === 'valid' && searchLoader === false && (

							<div className="search-content">
								<h6><i className="fa fa-check-circle" aria-hidden="true"></i> {text}</h6>
								<hr />
								<h4>A NBN<sup>&reg;</sup> service is available at this location. Check out our plans below</h4>
								<p style={{ textAlign: 'center' }}>{techType && (<>(  Connection type is {techType}) </>)}</p>
								<center><button className="button-57" role="button" onClick={e => planSelect()}><span className="text">VIEW PLANS</span><span>VIEW PLANS</span></button></center>
							</div>

						)}

						{validAddress === 'invalid' && searchLoader === false && (

							<div className="search-content-2">
								<h6><i className="fa fa-times-circle" aria-hidden="true"></i> {text}</h6>
								<hr />
								    <h5>A NBN® service is not available at your location now.</h5>
								 {/* <h5> Entered address is not available, please try again. .</h5>  */}
								{/* <h5>please try again.</h5> */}

								<p className="anotherAddress" onClick={e => resetHandler()}>Check another address</p>
							</div>

						)}


					</div>
				</div>
			</section>
		</div>

	);
}

export default Address;
